'use client'
import React from 'react'
import groundImage from '@/assets/images/ground.png'
import MyImage from '../../myImage'
import PlayerImage from '@/assets/images/placeholder/player.svg'
import { getImgURL } from '@/shared/utils'

const TeamPickImage = ({ data, bg }: any) => {
  const totalCredits = 100
  const credits = data?.aSelectedPlayerFan?.reduce(
    (acc: any, credit: any) => data?.oTPFan?._id !== credit._id && acc + credit.nRating,
    0
  )

  function renderPlayer(role: any) {
    const newData = data?.aSelectedPlayerFan?.filter(
      (player: any) => player?.oPlayer?.sPlayingRole === role
    )
    return (
      <div className="mt-8">
        {newData && newData.length > 0 && (
          <label className="text-lg text-white font-semibold mb-2">{playerRoles[role]}</label>
        )}
        <div className="flex flex-wrap justify-center md:gap-12 gap-3">
          {newData?.map((player: any) => (
            <div key={player._id} className="flex flex-col items-center justify-center">
              <span
                className={`${
                  player?.oPlayer?._id === data.oCapFan?.oPlayer?._id
                    ? 'bg-white text-black'
                    : player?.oPlayer?._id === data.oVCFan?.oPlayer?._id
                      ? 'bg-black !text-white'
                      : ''
                } ml-[-45px] mb-[-18px] z-10 text-base font-bold rounded-full h-6 w-6 flex items-center justify-center`}
              >
                {player?.oPlayer?._id === data.oCapFan?.oPlayer?._id
                  ? 'c'
                  : player?.oPlayer?._id === data.oVCFan?.oPlayer?._id
                    ? 'vc'
                    : null}
              </span>
              <MyImage
                src={
                  player?.oPlayer?.oImg?.sUrl ? getImgURL(player?.oPlayer?.oImg?.sUrl) : PlayerImage
                }
                className="rounded-full md:block hidden"
                height={62}
                width={62}
              />
              <MyImage
                src={
                  player?.oPlayer?.oImg?.sUrl ? getImgURL(player?.oPlayer?.oImg?.sUrl) : PlayerImage
                }
                className="rounded-full md:hidden block"
                height={45}
                width={45}
              />
              <span
                className={`${
                  player.oTeam?._id === data?.oTeamA?.oTeam?._id
                    ? 'bg-white text-black'
                    : 'bg-black text-white'
                } rounded-2xl px-2 w-[95px] md:w-[115px] mt-1 md:text-base text-xs line-clamp-1 md:line-clamp-2`}
              >
                {player?.oPlayer?.sShortName || player?.oPlayer?.sFirstName}
              </span>
              <span className="font-bold text-white">{player?.nRating}</span>
            </div>
          ))}
        </div>
      </div>
    )
  }

  const playerRoles: any = {
    wk: 'WICKET KEEPER',
    bat: 'BATTER',
    bowl: 'BOWLERS',
    all: 'ALL ROUNDER'
  }

  return (
    <div className="">
      <div
        className={`md:h-[944px] h-[852px] ${bg && 'rounded-t-lg'} md:rounded-3xl overflow-hidden bg-[#0E4000] text-center flex flex-col items-center  py-[-5px]`}
        style={{
          backgroundImage: `url(${groundImage.src})`,
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat, no-repeat'
        }}
      >
        <div
          style={{ backgroundColor: 'rgba(0, 0, 0 , 40% )' }}
          className=" w-full text-white flex justify-between items-center py-3 md:py-5 px-4 md:px-7 mb-8"
        >
          <div className="flex flex-col text-left">
            <span className="text-xs text-[#C3C3C3] md:text-base">Player</span>
            <span className="text-white text-sm md:text-lg">11/11</span>
          </div>
          <div className="flex gap-2 md:gap-4 items-center">
            <div className="bg-white px-3 py-1.5 text-[#373737] rounded-lg font-medium text-xs md:text-base">
              {data?.oTeamA?.oTeam?.sAbbr} : {data?.oTeamA?.nCount}
            </div>
            <div className="bg-[#080C0F] px-3 py-1.5 text-white rounded-lg font-medium text-xs md:text-base">
              {data?.oTeamB?.oTeam?.sAbbr} : {data?.oTeamB?.nCount}
            </div>
          </div>
          <div className="flex flex-col text-xs md:text-base">
            <span className="text-xs text-[#C3C3C3] md:text-base">Credit Left</span>
            <span className="text-white text-sm md:text-lg">{totalCredits - credits}/100</span>
          </div>
        </div>
        {renderPlayer('wk') || renderPlayer('wkbat')}
        {renderPlayer('bat')}
        {renderPlayer('all')}
        {renderPlayer('bowl') || renderPlayer('wkbat')}
      </div>
    </div>
  )
}

export default TeamPickImage
